// extracted by mini-css-extract-plugin
module.exports = {"dark_toggle":"darkModeToggle-module--dark_toggle--3Yk6P"};